import type { UploadProgress } from '@routes/sidebar/admin-center/creator/___pages___/elements/model/types.ts';

export const INITIAL_UPLOAD_PROGRESS: UploadProgress = {
    isOpened: false,
    filename: '',
    sizeInMB: 0,
    timeInSeconds: 0,
    percentageProgress: 0,
};
